import { render, staticRenderFns } from "./special.vue?vue&type=template&id=92b024da&scoped=true&"
import script from "./special.vue?vue&type=script&lang=js&"
export * from "./special.vue?vue&type=script&lang=js&"
import style0 from "./special.vue?vue&type=style&index=0&id=92b024da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b024da",
  null
  
)

export default component.exports